var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEbdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675.73 159.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fichier 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EBD_logo",
    "data-name": "EBD logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.93,69.75H110.7L77.83,22.25h-.58v47.5H64.62V0h11.3l32.83,47.55h.62V0h12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,69.75,156.24,0h15.59l24.59,69.75H182.94l-5.79-17.19H150.93l-5.76,17.19Zm42.06-27.34-9.44-28.09h-.55l-9.43,28.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.22,0h26.7C248,0,255.54,7.7,255.54,18.09c0,8.47-5.38,13.25-12.2,14.84v.69c7.43.38,14.92,6.56,14.92,17.13,0,10.86-7.84,19-23.8,19H206.22Zm25.13,29.67c6.57,0,11.55-3.81,11.55-10,0-5.37-3.85-9.3-11.27-9.3H218.86V29.67Zm1.09,29.53c9.16,0,13-3.89,13-9.44,0-6.23-4.84-11-12.63-11H218.86V59.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,0h12.63V59.16h30.72V69.75H271Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.06,0h50.81V10.59H337.69V29.53h35.82V40.13H337.69v19h38.45V69.75H325.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H50.81V10.59H12.63V29.53H48.46V40.13H12.63v19H51.08V69.75H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.68,69.75V0h20.46c20.77,0,33.38,13.08,33.38,34.81s-12.6,34.94-33.85,34.94Zm19.38-10.92c14.54,0,21.93-8,21.93-24s-7.39-23.87-21.56-23.87h-7.11V58.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.68,88.78h50.81V99.38H402.31v18.94h35.82v10.59H402.31v19h38.45v10.59H389.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.06,158.53V88.78h20.46c20.77,0,33.38,13.08,33.38,34.81s-12.6,34.94-33.85,34.94Zm19.38-10.92c14.54,0,21.93-8,21.93-24S359,99.72,344.8,99.72h-7.11v47.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,88.78H26.7c15.13,0,22.62,7.7,22.62,18.09,0,8.47-5.38,13.25-12.2,14.84v.69C44.55,122.78,52,129,52,139.53c0,10.86-7.84,19-23.8,19H0Zm25.13,29.67c6.57,0,11.55-3.81,11.55-10,0-5.37-3.85-9.3-11.27-9.3H12.63v19.25ZM26.22,148c9.16,0,13-3.89,13-9.44,0-6.23-4.84-11-12.63-11H12.63V148Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,88.78l17.06,30.86h.68l17.06-30.86h14.27L93.78,132.52v26H81.18v-26L55.8,88.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.92,98.41c-7.91,0-12.6,3.84-12.63,9.09-.07,5.82,6.13,8.24,11.85,9.6l6.54,1.63c10.48,2.49,20.47,8,20.5,20.09,0,12.3-9.74,20.64-26.46,20.64-16.25,0-26.57-7.8-27.08-21.66h12.43c.52,7.32,6.64,10.86,14.55,10.86,8.24,0,13.89-4,13.93-9.95,0-5.41-5-7.77-12.54-9.67l-7.93-2c-11.48-3-18.6-8.72-18.6-18.73,0-12.33,11-20.57,25.62-20.57,14.84,0,24.89,8.34,25.13,20.13H491.07C490.42,101.91,485.44,98.41,477.92,98.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.72,158.53H517.09V88.78h12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.14,99.05c-11.27,0-19.41,8.72-19.41,24.41s8,24.55,19.69,24.55c10.48,0,17.13-6.3,17.34-16.24H576.67v-9.87H605v8.38c0,18-12.37,29.09-29.63,29.09-19.24,0-32.32-13.69-32.32-35.76,0-22.48,13.69-35.9,31.95-35.9,15.43,0,27.28,9.54,29.42,23.23H591.52C589.27,103.55,583.55,99.05,575.14,99.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.73,158.53H664.5L631.63,111h-.58v47.51H618.42V88.78h11.3l32.83,47.55h.62V88.78h12.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbdLogo);
export default __webpack_public_path__ + "static/media/EBD_logo.f6d1b4d52895bd276d28973a022cfd2c.svg";
export { ForwardRef as ReactComponent };